
  const { hot } = require("react-hot-loader/root")
  import Component from "/codebuild/output/src646894754/src/src/views/components/sitemap/index.tsx"

  export default hot(Component)
  